import config from '../config';

export const getDocumentUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  if (path.startsWith('/')) {
    const apiUrl = (config.API_URL || '').replace(/\/+$/, '');
    return apiUrl ? `${apiUrl}${path}` : path;
  }

  const baseUrl = (config.S3_PUBLIC_BASE_URL || '').replace(/\/+$/, '');
  const cleanPath = String(path).replace(/^\/+/, '');

  return baseUrl ? `${baseUrl}/${cleanPath}` : `/${cleanPath}`;
};
